module.exports = __webpack_public_path__ + "img/clock.06bbec85.svg";